import { useContext, useMemo } from 'react';
import { AgentProgressContext } from './context';
import type { CardState, TimelineNode } from './interfaces';
import { buildTimeline, deriveCardState, flattenTimelineTree } from './utils.timeline';

interface AgentProgressTimelineResult {
  timeline: TimelineNode[];
  cardState: CardState | undefined;
}

export function useAgentProgressTimeline(): AgentProgressTimelineResult {
  const progress = useContext(AgentProgressContext);

  return useMemo(() => {
    if (!progress) return { timeline: [], cardState: undefined };
    const timeline = buildTimeline(progress);
    const flat = flattenTimelineTree(timeline);
    const cardState = deriveCardState(progress, flat);
    return { timeline, cardState };
  }, [progress]);
}
